/**
 * The reference assistant's realtime entry point: the handler
 * `useInboxLiveUpdates` dispatches `referenceAssistant.*` hints to. Kept
 * apart from the main entry so the app-wide handler list loads no UI.
 */
export { referenceAssistantRealtimeHandler } from './referenceAssistantRealtime';
